import React from "react";
import { MdDelete } from "react-icons/md";
import ButtonImagePermission from "../../../../components/UI/Button/ButtonImagePermission";
import FileDownloader from "../../../../components/UI/Button/FileDownloader";
import funcionalidades from "../../../../context/AuthContext.funcionalidades";

const useColumns = ({ excluirAssociacao }) => {
  const columns = [
    {
      name: "Descrição",
      selector: "dtInicio",
      minWidth: "250px",
      center: false,
      sortable: false,
      cell: (row) => (
        <span>
          TSPS - Auto de Infração Nº <strong>{row.nuPAF}</strong> - <strong>{row.txNmFormal}</strong>
        </span>
      ),
    },
    {
      name: "Ações",
      selector: "nuProdutoAcaoFiscal",
      width: "100px",
      center: true,
      sortable: true,
      cell: (row) => (
        <>
          <FileDownloader tooltip="Visualizar Documento" />
          <ButtonImagePermission
            permission={funcionalidades.os.prorrogarOs}
            variant="bg-link"
            className="btn-lg pa-0 p-0 mx-1"
            buttonImage={
              <MdDelete size={20} className="btn-sm text-danger p-0 btn btn-bg-transparent" title="Excluir" />
            }
            tooltipImage="Excluir"
            onClick={() => {
              excluirAssociacao({ row });
            }}
          />
        </>
      ),
    },
  ];

  const columnsAssoc = [
    {
      name: "Descrição",
      selector: "dtInicio",
      minWidth: "250px",
      center: false,
      sortable: false,
      cell: (row) => <span>{row.txNmFormal}</span>,
    },
  ];

  return { columns, columnsAssoc };
};

export default useColumns;
